import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURLCOT } from "../../../Config";
import { DownloadTableExcel } from "react-export-table-to-excel";

export default function PdPending() {
  const token = localStorage.getItem("token");

  const [pdList, setPdList] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [width, setWidth] = React.useState(window.innerWidth < 768);

  const pdPendingTB = React.useRef(null);

  useEffect(() => {
    getPDpending();
  }, []);
  const getPDpending = () => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/PD/api/pdPendingClients`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setPdList(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  return (
    <div className={width ? "" : "p-3"}>
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className="nav-link active tab-item"
              id="pdpending-tab"
              data-bs-toggle="tab"
              data-bs-target="#pdpending"
              type="button"
              role="tab"
              aria-controls="pdpending"
              aria-selected="true"
            >
              PD Pending
            </button>
          </li>
        </ul>

        <div
          className={width ? "tab-content mt-1" : "tab-content mt-3"}
          id="myTabsContent"
        >
          <div
            className="tab-pane fade show active"
            id="pdpending"
            role="tabpanel"
            aria-labelledby="pdpending-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <div className="d-flex">
                    <DownloadTableExcel
                      filename="PdPendingCT"
                      sheet="users"
                      currentTableRef={pdPendingTB.current}
                    >
                      <button
                        className="btn btn-success border"
                        style={{
                          width: "120px",
                          backgroundColor: "black",
                        }}
                      >
                        {" "}
                        Download{" "}
                      </button>
                    </DownloadTableExcel>
                  </div>
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table
                        className="table table-striped mt-3"
                        ref={pdPendingTB}
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>
                              App Client Id
                            </th>

                            <th style={{ textAlign: "center" }}>Client name</th>
                            <th style={{ width: "150px", textAlign: "center" }}>
                              Mobile
                            </th>
                            <th style={{ textAlign: "center" }}>Branch</th>
                            {/* <th style={{ textAlign: "center" }}>
                              Client State
                            </th> */}

                            {/* <th style={{ textAlign: "center" }}>PD by</th> */}

                            {/* <th style={{ textAlign: "center" }}>
                              Date CB approved
                            </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {pdList && pdList.length > 0 ? (
                            pdList.map((detail, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  {index + 1}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {detail.appClientId}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {detail.clientName}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {detail.clientMobileNo}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {detail.branchName}
                                </td>
                                {/* <td style={{ textAlign: "left" }}>
                                  {detail.clientState}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {detail.entryDate || "-"}
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ textAlign: "center" }}>
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
